import { create } from 'zustand';
import { ApiUtils, FileApi, RequestStrategyEnum } from '@shared/api';

interface IDeleteApplicationFileStore {
  loading: boolean;
  error: string | null;
  success: boolean;
  deleteApplicationFiles: (fileId: string, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useDeleteApplicationFileStore = create<IDeleteApplicationFileStore>((set) => ({
  loading: false,
  error: null,
  success: false,

  deleteApplicationFiles: ApiUtils.wrapperApi(async (fileId: string, signal?: AbortSignal) => {
    try {
      set({ loading: true, error: null });
      await FileApi.deleteApplicationFile(fileId, signal);
      set({ success: true, loading: false });
    } catch (error) {
      set({ error: (error as Error).message, loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ success: false, loading: false, error: null }),
}));
